import React from 'react';

const ContractsIcon = ({ isActive }) => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 4H17C17.5304 4 18.0391 4.21071 18.4142 4.58579C18.7893 4.96086 19 5.46957 19 6V18C19 18.5304 18.7893 19.0391 18.4142 19.4142C18.0391 19.7893 17.5304 20 17 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V5C5 4.73478 5.10536 4.48043 5.29289 4.29289C5.48043 4.10536 5.73478 4 6 4M9 4V22'
        stroke={isActive ? '#ffffffa3' :'#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.9998 11.6667C14.7362 11.6667 15.3332 11.0697 15.3332 10.3333C15.3332 9.59695 14.7362 9 13.9998 9C13.2635 9 12.6665 9.59695 12.6665 10.3333C12.6665 11.0697 13.2635 11.6667 13.9998 11.6667Z'
        stroke={isActive ? '#ffffffa3' :'#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 16V15.3333C12 14.9797 12.1405 14.6406 12.3905 14.3905C12.6406 14.1405 12.9797 14 13.3333 14H14.6667C15.0203 14 15.3594 14.1405 15.6095 14.3905C15.8595 14.6406 16 14.9797 16 15.3333V16'
        stroke={isActive ? '#ffffffa3' :'#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ContractsIcon;
